"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCoding = exports.MedicalCodingStatus = exports.MedicalCodingEntryType = exports.MedicalCodingType = void 0;
var MedicalCodingType;
(function (MedicalCodingType) {
    MedicalCodingType["MedicalTerm"] = "MEDICAL_TERM";
    MedicalCodingType["Medication"] = "MEDICATION";
})(MedicalCodingType = exports.MedicalCodingType || (exports.MedicalCodingType = {}));
var MedicalCodingEntryType;
(function (MedicalCodingEntryType) {
    MedicalCodingEntryType["Meddra"] = "MEDDRA";
    MedicalCodingEntryType["AtcIndex"] = "ATC_INDEX";
    MedicalCodingEntryType["KoDD"] = "KODD";
    MedicalCodingEntryType["WhoDDB3"] = "WHODD_B3";
    MedicalCodingEntryType["WhoDDC3"] = "WHODD_C3";
    MedicalCodingEntryType["DirectInput"] = "DIRECT_INPUT";
})(MedicalCodingEntryType = exports.MedicalCodingEntryType || (exports.MedicalCodingEntryType = {}));
var MedicalCodingStatus;
(function (MedicalCodingStatus) {
    MedicalCodingStatus["Wait"] = "WAIT";
    MedicalCodingStatus["Completed"] = "COMPLETED";
})(MedicalCodingStatus = exports.MedicalCodingStatus || (exports.MedicalCodingStatus = {}));
class StudyCoding {
}
exports.StudyCoding = StudyCoding;
//# sourceMappingURL=studyCoding.js.map